import { grayPaletteDark, redPaletteDark, royalBluePaletteDark } from '../../../themes/dark-colors';

export const fieldContainerDarkTheme = {
  requiredSignColor: royalBluePaletteDark[1000],
  helper: {
    color: grayPaletteDark[600],
  },
  error: {
    color: redPaletteDark[800],
  },
  label: {
    // DEV-30432: handle different colors for different size
    s: {
      color: grayPaletteDark[800],
    },
    m: {
      color: grayPaletteDark[800],
    },
    l: {
      color: royalBluePaletteDark[1000],
    },
  },
};
